import { type FC } from 'react';


interface InlineMessageProps {
    status?: 'info' | 'warning' | 'error' | 'success';
    title?: string;
    children: React.ReactNode;
    className?: string;
}

const InlineMessage: FC<InlineMessageProps> = ({ children, status = 'error', title, className = '' }) => {
    const containerClassName = `inline-message status-${status} ${className}`.trim();
    return (
        <div className={containerClassName}>
            <div className="inline-message-content-box">
                {title && (
                    <div className="inline-message-title">{title}</div>
                )}
                {children}
            </div>
        </div>
    );
};

export default InlineMessage;
